import {
  ActionIcon,
  Anchor,
  Badge,
  Button,
  Flex,
  Stack,
  Text,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { observer } from 'mobx-react';
import {
  CheckOffId,
  useViewParticipantOnboardingStore,
} from '../../../store/ViewParticipantOnboardingStore';
import { useParticipantDataStore } from '../../../store';
import { BMSSampleDecision } from '@web/common';
import { BMSSampleModal } from './BMSSampleModal';
import { MyIcon } from '@web/common-ui';

export const BMSSample = observer(() => {
  const stateStore = useViewParticipantOnboardingStore();
  const participantDataStore = useParticipantDataStore();
  const [opened, { open, close }] = useDisclosure(false);

  const bmsSample = participantDataStore.bmsSample;

  const handleSave = (decision: BMSSampleDecision) => {
    stateStore.setCurrentCheckpointState(
      CheckOffId.BMS,
      decision !== BMSSampleDecision.BRING_LATER,
    );
    const participantId = participantDataStore.data?.Participant?.participantId;
    if (participantId) {
      participantDataStore.setBmsSampleDecision(participantId, decision);
    }
    close();
  };

  if (bmsSample?.broughtAt) {
    return (
      <Stack gap="10px">
        <Flex gap="8px" align="center">
          <Text>BMS:</Text>
          <Badge color="primary">Mitgebracht</Badge>
        </Flex>
        <Flex gap="10px" align="center">
          <Flex gap="10px" align="center">
            <Text>BMS-ID: </Text>
            <Text fw="500">{bmsSample.bmsId}</Text>
          </Flex>
          <Flex gap="10px" align="center">
            <Text>Soll-Menge: </Text>
            <Text fw="500">{bmsSample.sampleGrams} g</Text>
          </Flex>
          <Anchor
            href={bmsSample.surveyLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Fragebogen ausfüllen
          </Anchor>
        </Flex>
      </Stack>
    );
  }

  if (bmsSample?.decidedNotToBringAt) {
    return (
      <>
        <Stack gap="10px">
          <Flex gap="8px" align="center">
            <Text>BMS-Sample:</Text>
            <Badge color="red">Nicht mitgebracht</Badge>
            <ActionIcon
              variant="subtle"
              size="sm"
              onClick={open}
              aria-label="Entscheidung ändern"
              title="Entscheidung ändern"
            >
              <MyIcon name="edit" style={{ fill: 'grey' }} />
            </ActionIcon>
          </Flex>
          <Flex gap="10px" align="center">
            <Text>Soll-Menge: </Text>
            <Text fw="500">{bmsSample.sampleGrams} g</Text>
          </Flex>
        </Stack>
        <BMSSampleModal opened={opened} onClose={close} onSave={handleSave} />
      </>
    );
  }

  return (
    <>
      <Stack gap="10px">
        <Flex gap="8px" align="center" w="100%">
          <Text>BMS:</Text>
          <Badge color="gray">Ausstehend</Badge>
          <Button color="orange" variant="outline" onClick={open}>
            BMS Abgabe eintragen und Fragebogen ausfüllen
          </Button>
        </Flex>
        {bmsSample && (
          <Flex gap="10px" align="center">
            <Text>Soll-Menge: </Text>
            <Text fw="500">{bmsSample.sampleGrams} g</Text>
          </Flex>
        )}
      </Stack>
      <BMSSampleModal opened={opened} onClose={close} onSave={handleSave} />
    </>
  );
});
